import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {TuiButton, TuiTextfield} from '@taiga-ui/core';
import type {TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';

@Component({
  selector: 'app-whatsapp-test-message-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TuiButton,
    TuiTextfield,
    TranslateModule,
    NgxMaskDirective,
  ],
  providers: [provideNgxMask()],
  templateUrl: './whatsapp-test-message-dialog.component.html',
})
export class WhatsappTestMessageDialogComponent {
  form: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<string | null, void>,
  ) {
    this.form = this.fb.group({
      phone: ['', [Validators.required]],
    });
  }

  submit(): void {
    if (this.form.valid) {
      const value = this.form.get('phone')?.value ?? '';
      const digits = typeof value === 'string' ? value.replace(/\D/g, '') : '';
      this.context.completeWith(digits || null);
    }
  }

  cancel(): void {
    this.context.completeWith(null);
  }
}
